import type {
  Metafield,
  ProductOption,
} from '@shopify/hydrogen-react/storefront-api-types'
import { t } from 'i18next'

export function mapStorefrontOptionLabelOverride({
  option,
  optionIndex,
  optionLabelOverrides,
  isLinkedBottom,
}: {
  option: ProductOption
  optionIndex: number
  optionLabelOverrides: Metafield
  isLinkedBottom?: boolean
}) {
  const parsedLabelOverrides = JSON.parse(optionLabelOverrides?.value ?? '[]')

  if (!parsedLabelOverrides.length || !parsedLabelOverrides[optionIndex]) {
    if (isLinkedBottom) {
      return t('product.choose_your_bottoms')
    }

    return option.name
  }

  return parsedLabelOverrides[optionIndex]
}
